import React, { useEffect, useState } from 'react'
import InfoBox from './InfoBox'
import './About.css'
import './Common.css'

import aboutDataTr from '../data/jsons/about.tr.json'
import aboutDataEn from '../data/jsons/about.en.json'

import SpringPhoto from '../data/icons/Spring.svg'
import ServerPhoto from '../data/icons/Server.svg'
import DatabasePhoto from '../data/icons/Database.svg'
import AutomationPhoto from '../data/icons/Automation.svg'
import MachinePhoto from '../data/icons/Machine.svg'
import DataEngPhoto from '../data/icons/Data.svg'

const iconMap = {
    "Spring": SpringPhoto,
    "Server": ServerPhoto,
    "Database": DatabasePhoto,
    "Automation": AutomationPhoto,
    "Machine": MachinePhoto,
    "Data": DataEngPhoto
};

function About() {
    const [isEnglish, setIsEnglish] = useState(
        localStorage.getItem('pageLanguage') === 'true'
    );

    useEffect(() => {
        const handleLangChange = () => {
            setIsEnglish(localStorage.getItem('pageLanguage') === 'true');
        };
        window.addEventListener("languageChange", handleLangChange);
        return () => {
            window.removeEventListener("languageChange", handleLangChange);
        };
    }, []);

    const aboutData = isEnglish ? aboutDataEn : aboutDataTr;

    return(
        <div id='About-Container' className='Containers'>
            <div className='Top-Section'>
                <p className='Page-Header'>{aboutData.header.title}</p>
                <hr className='Header-Line'/>
                <div className='About-Text-Section'>
                    {aboutData.header.paragraphs.map((para, index) => (
                        <p key={index} className='Page-Text'>{para}</p>
                    ))}
                </div>
            </div>

            {aboutData.contentSections.map((section) => (
                <div key={section.sectionId}>
                    <p className='Sub-Header'>{section.header}</p>
                    <div className='Info-Box-Section'>
                        {section.items.map((item, index) => (
                            <InfoBox 
                                key={index}
                                ImageSource={iconMap[item.icon]} // Map üzerinden ikonu çekiyoruz
                                InfoHeader={item.title} 
                                InfoText={item.description}
                            />
                        ))}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default About